import { trackEvent } from "src/utils/api/tracker";
import { trackViewContentWithParamsExsf0 } from "src/utils/services/ConversionTracker";
import { ActionHandler, ActionHandlerParams } from "..";
import { getPageSetSurvey } from "./util";

type Params = {
  eventName?: string;
};

export const onStartPaymentSurvey: ActionHandler = ({
  pageSet,
  page,
  params = {},
}: {
  params?: Params;
} & ActionHandlerParams) => {
  const survey = getPageSetSurvey(pageSet, page);
  const eventName = params.eventName || `Started${survey.name}`;

  trackEvent(eventName);
  trackViewContentWithParamsExsf0({
    content_type: `FBMG-${eventName}`,
  });
};
